var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-chart"},[_c('canvas',{attrs:{"width":"1","id":"under-performing-stats-chart"}})])}]

export { render, staticRenderFns }